{
  "actions": {
    "cancel": "Cancel"
  },
  "list": {
    "title": "Coordinators & commissions",
    "subtitle": "{{n}} active coordinators · no salaries, a share of each booking fee",
    "new": "New coordinator",
    "caption": "Coordinators",
    "stats": {
      "remaining": "Total remaining to transfer",
      "pending": "Pending commissions",
      "pendingSub": "Bookings customers haven't paid yet",
      "transferredThisMonth": "Transferred this month"
    },
    "empty": {
      "title": "No coordinators",
      "action": "Add coordinator"
    },
    "columns": {
      "name": "Coordinator",
      "agreement": "Current agreement",
      "monthBookings": "Bookings this month",
      "earned": "Earned",
      "transferred": "Transferred",
      "remaining": "Remaining",
      "pending": "Pending",
      "portal": "Portal"
    },
    "dialog": {
      "title": "New coordinator",
      "description": "No salary — a share of each booking fee per the agreement."
    }
  },
  "form": {
    "firstName": "First name",
    "lastName": "Last name",
    "nationalId": "National ID",
    "nationalIdHint": "Stored encrypted; shown in full only on a logged request",
    "phone": "Mobile",
    "email": "Email",
    "emailHint": "Used to sign in to the coordinator portal",
    "agreementType": "Agreement type",
    "typePercentage": "Percentage of fee",
    "typeFixed": "Fixed amount per booking",
    "percentLabel": "Percentage (%)",
    "amountLabel": "Amount ({{currency}})",
    "validFrom": "Valid from",
    "saving": "Saving…",
    "save": "Save details",
    "create": "Add coordinator",
    "saved": "Details saved",
    "saveFailed": "Couldn't save",
    "errors": {
      "firstName": "First name is required",
      "lastName": "Last name is required",
      "phone": "Invalid mobile number",
      "email": "Invalid email address",
      "nationalId": "10 digits starting with 1 or 2",
      "valuePositive": "Enter a value greater than zero",
      "percentMax": "Percentage can't exceed 100%"
    },
    "whatsapp": "Assigned agency WhatsApp number",
    "whatsappHint": "Agency-owned number the coordinator uses with customers — kept in the system only, not in the contract",
    "createdWithContract": "Coordinator added and contract sent for signing",
    "contractSetupMissing": "Coordinators can't be added until the “Coordinator contract” setup (agency signatory and signature) is complete.",
    "openSettings": "Open settings",
    "contractWillBeSent": "The contract is emailed to the coordinator to read and sign online, then they choose a portal password. The signed contract is attached to the agreement automatically."
  },
  "detail": {
    "edit": "Edit details",
    "recordPayout": "Record transfer",
    "nothingRemaining": "No remaining amount to transfer",
    "editDialogTitle": "Edit coordinator details",
    "stats": {
      "earned": "Total earned",
      "transferred": "Transferred",
      "owed": "Owed by coordinator",
      "remaining": "Remaining to transfer",
      "pending": "Pending (booking unpaid)"
    },
    "tabs": {
      "ledger": "Commission ledger",
      "payouts": "Transfers & receipts",
      "agreements": "Agreements",
      "contracts": "Contracts"
    }
  },
  "ledger": {
    "status": "Status",
    "allStatuses": "All statuses",
    "month": "Month",
    "export": "Export CSV",
    "caption": "Commission ledger",
    "empty": "No commissions",
    "columns": {
      "booking": "Booking",
      "customer": "Customer",
      "fee": "Fee",
      "share": "Share",
      "date": "Date",
      "status": "Status"
    }
  },
  "payouts": {
    "caption": "Transfers",
    "empty": "No transfers yet",
    "voided": "Transfer cancelled; commissions returned to earned",
    "viewReceipt": "View receipt",
    "voidLabel": "Cancel transfer dated {{date}}",
    "voidConfirm": "Cancel this transfer? The included commissions will return to earned.",
    "void": "Cancel",
    "methods": {
      "bank_transfer": "Bank transfer",
      "cash": "Cash"
    },
    "columns": {
      "date": "Date",
      "amount": "Amount",
      "method": "Method",
      "reference": "Bank reference",
      "receipt": "Receipt",
      "recordedBy": "Recorded by"
    }
  },
  "profile": {
    "title": "Details",
    "nationalId": "National ID",
    "reveal": "Show national ID (logged)",
    "phone": "Mobile",
    "email": "Email",
    "agreement": "Agreement",
    "from": "From {{date}}",
    "changeEmail": "Change email",
    "whatsapp": "Agency WhatsApp",
    "noWhatsapp": "Not set"
  },
  "portal": {
    "title": "Coordinator portal account",
    "lastLogin": "Last sign-in {{when}}",
    "note": "In the portal the coordinator sees only their bookings and share (earned, transferred, remaining, pending) and transfer receipts — not fees or customer contact details.",
    "resetPassword": "Reset password",
    "disable": "Disable",
    "enable": "Enable",
    "toasts": {
      "reset": "Reset link sent",
      "disabled": "Account disabled",
      "enabled": "Account enabled",
      "linkResent": "The set-password link was sent again"
    },
    "contract": "Contract:",
    "awaitingContract": "The portal account is created once the coordinator signs the contract.",
    "noContract": "No contract is waiting for a signature. Send the contract so the coordinator can sign in.",
    "signedNoPassword": "The coordinator signed the contract but has not chosen a password yet.",
    "sendContract": "Send contract",
    "resendLink": "Resend password link"
  },
  "payoutDialog": {
    "title": "Record commission transfer",
    "remaining": "{{name}} · remaining",
    "entries": "Commissions included in the transfer",
    "reversal": "reversal entry (required)",
    "amount": "Amount transferred ({{currency}})",
    "paidAt": "Transfer date",
    "reference": "Bank reference",
    "receipt": "Transfer receipt",
    "info": "The transfer and receipt will appear in the coordinator portal once saved.",
    "save": "Save transfer",
    "recorded": "Transfer recorded"
  },
  "agreements": {
    "intro": "Schedule an agreement for a future date or change the current agreement from today. The coordinator gets a portal notification and an email for every change; previously confirmed bookings keep their agreement.",
    "new": "New agreement",
    "rangeTo": "From {{from}} to {{to}}",
    "rangeOpen": "From {{from}} — open-ended",
    "viewFile": "View agreement file",
    "file": "File",
    "editScheduled": "Edit scheduled agreement",
    "cancelScheduled": "Cancel scheduled agreement",
    "cancelDescription": "The agreement ({{label}}) scheduled from {{date}} will be cancelled and the current agreement continues. The coordinator will be notified.",
    "cancelConfirm": "Cancel agreement",
    "cancelled": "Scheduled agreement cancelled and coordinator notified",
    "empty": "No agreements.",
    "fileTitle": "Agreement file",
    "dialog": {
      "titleEdit": "Edit scheduled agreement",
      "titleNew": "New agreement",
      "startsToday": "Takes effect today and closes the current agreement.",
      "startsLater": "Starts on the selected date; the current agreement continues until the day before.",
      "typePercentage": "Percentage of fee",
      "typeFixed": "Fixed amount",
      "percentLabel": "Percentage (%)",
      "amountLabel": "Amount ({{currency}})",
      "validFrom": "Valid from",
      "supersedeOne": "This agreement replaces an agreement starting on or after the same date; that agreement will be cancelled.",
      "supersedeMany": "This agreement replaces {{n}} agreements starting on or after the same date; they will be cancelled.",
      "saveEdit": "Save changes",
      "change": "Change agreement",
      "schedule": "Schedule agreement",
      "edited": "Agreement updated and coordinator notified",
      "changed": "Agreement changed from today and coordinator notified",
      "scheduled": "Agreement scheduled and coordinator notified",
      "contractNote": "On save, a new contract with these terms is emailed to the coordinator to sign; the signed contract is attached to the agreement automatically."
    },
    "awaitingSignature": "Awaiting signature"
  }
}
